
export const flattenDeep = arr => {
  return arr.reduce((acc, val) => Array.isArray(val) ? acc.concat(flattenDeep(val)) : acc.concat(val), []);
};

export const join = (arr, separator) => {
  return flattenDeep(arr).filter(n => n).join(separator);
};
